export const table = {
    user: {
        all: [
            "id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "groupStatus",
            "groupName",
            "joinDate",
            "joinChannel",
            "firstAccessDevice",
            "recentLogin",
            "stayTime",
            "photo",
            "alertKaKao",
            "alertSms",
            "alertEmail",
            "marketingKaKao",
            "marketingSms",
            "marketingEmail",
            "activityManagementNumber",
            "serviceType",
            "testNation",
            "testCity",
            "testDate",
            "testStartTime",
            "testEndTime",
            "applicationCategory",
            "year",
            "round",
            "testSubject",
            "testGrade",
            "category1",
            "category2",
            "category3",
            "examName",
            "detailedDescription",
            "departureLanguage",
            "arrivalLanguage",
            "isChoice",
            "isShort",
            "isLong",
            "applicationStartDate",
            "applicationEndDate",
            "applicationStatus",
            "examStatus",
            "candidateStatus",
            "announceDate",
            "announceTime",
            "examResults",
            "scoredPoints",
            "feedbackStatus",
            "feedbackCompleteDate",
            "certificate",
            "paymentDate",
            "paymentDetails",
            "used",
            "discount",
            "discountDescription",
            "paymentAmount",
            "paymentMethod",
            "availablePoints",
            "refundStatus",
            "consultationDate",
            "consultationCompleteDate",
            "consultationStatus",
            "inquiryCategory",
            "answerCategory",
            "answerer",
            "inquiryTitle",
            "inquiryContents",
            "attachedFile",
            "adminMemo",
        ],
        user: [
            "id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "groupStatus",
            "groupName",
            "joinDate",
            "joinChannel",
            "firstAccessDevice",
            "recentLogin",
            "stayTime",
            "photo",
            "alertKaKao",
            "alertSms",
            "alertEmail",
            "marketingKaKao",
            "marketingSms",
            "marketingEmail",
            "adminMemo",
        ],
        activity: [
            "id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "testNation",
            "testCity",
            "testDate",
            "testStartTime",
            "testEndTime",
            "applicationCategory",
            "year",
            "round",
            "testSubject",
            "testGrade",
            "category1",
            "category2",
            "category3",
            "examName",
            "detailedDescription",
            "departureLanguage",
            "arrivalLanguage",
            "isChoice",
            "isShort",
            "isLong",
            "applicationStartDate",
            "applicationEndDate",
            "applicationStatus",
            "examStatus",
            "candidateStatus",
            "announceDate",
            "announceTime",
            "examResults",
            "scoredPoints",
            "feedbackStatus",
            "feedbackCompleteDate",
            "certificate",
            "adminMemo"
        ],
        transaction: [

            "id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "groupStatus",
            "groupName",
            "joinDate",
            "joinChannel",
            "firstAccessDevice",
            "recentLogin",
            "stayTime",
            "photo",
            "alertKaKao",
            "alertSms",
            "alertEmail",
            "paymentDate",
            "paymentDetails",
            "used",
            "discount",
            "discountDescription",
            "paymentAmount",
            "paymentMethod",
            "availablePoints",
            "refundStatus",
            "adminMemo",
        ],
        ask: [
            "id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "groupStatus",
            "groupName",
            "joinDate",
            "joinChannel",
            "firstAccessDevice",
            "recentLogin",
            "stayTime",
            "photo",
            "alertKaKao",
            "alertSms",
            "alertEmail",
            "consultationDate",
            "consultationCompleteDate",
            "consultationStatus",
            "inquiryCategory",
            "answerCategory",
            "answerer",
            "inquiryTitle",
            "inquiryContents",
            "attachedFile",
            "adminMemo",
        ]
    },
    expert: {
        all: ["id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "groupStatus",
            "groupName",
            "joinDate",
            "joinChannel",
            "firstAccessDevice",
            "recentLogin",
            "stayTime",
            "photo",
            "alertKaKao",
            "alertSms",
            "alertEmail",
            "marketingKaKao",
            "marketingSms",
            "marketingEmail",
            "resume",
            "categoryB",
            "categoryM",
            "categoryS",
            "expertServiceType",
            "serviceTime",
            "expertStatus",
            "expertDate",
            "priority",
            "expertLevel",
            "rating",
            "reviews",
            "activities",
            "matchingDecline",
            "settleBank",
            "settleAccount",
            "settleOwner",
            "totalCareer",
            "education",
            "testNation",
            "testCity",
            "applicationCategory",
            "year",
            "round",
            "testSubject",
            "testGrade",
            "category1",
            "category2",
            "category3",
            "examName",
            "detailedDescription",
            "departureLanguage",
            "arrivalLanguage",
            "purpose",
            "activityCareer",
            "activityCareerCount",
            "activityDoneDate",
            "settleDueDate",
            "settlePlaned",
            "settleAddition",
            "settleAmount",
            "settleStatus",
            "settledDate",
            "unspent",
            "adminMemo",
        ],
        user: [
            "id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "groupStatus",
            "groupName",
            "joinDate",
            "joinChannel",
            "firstAccessDevice",
            "recentLogin",
            "stayTime",
            "photo",
            "alertKaKao",
            "alertSms",
            "alertEmail",
            "resume",
            "categoryB",
            "categoryM",
            "categoryS",
            "expertServiceType",
            "serviceTime",
            "expertStatus",
            "priority",
            "expertDate",
            "expertLevel",
            "rating",
            "reviews",
            "activities",
            "matchingDecline",
            "settleBank",
            "settleAccount",
            "settleOwner",
            "totalCareer",
            "education",
            "adminMemo",
        ],
        settlement: [
            "id",
            "site",
            "userType",
            "userSubscriptionStatus",
            "name",
            "age",
            "gender",
            "email",
            "mobilePhone",
            "city",
            "address",
            "groupStatus",
            "groupName",
            "joinDate",
            "joinChannel",
            "firstAccessDevice",
            "recentLogin",
            "stayTime",
            "photo",
            "alertKaKao",
            "alertSms",
            "alertEmail",
            "marketingKaKao",
            "marketingSms",
            "marketingEmail",
            "rating",
            "reviews",
            "activities",
            "matchingDecline",
            "settleBank",
            "settleAccount",
            "settleOwner",
            "totalCareer",
            "education",
            "testNation",
            "testCity",
            "applicationCategory",
            "year",
            "round",
            "testSubject",
            "testGrade",
            "category1",
            "category2",
            "category3",
            "examName",
            "detailedDescription",
            "departureLanguage",
            "arrivalLanguage",
            "purpose",
            "activityCareer",
            "activityCareerCount",
            "activityDoneDate",
            "settleDueDate",
            "settlePlaned",
            "settleAddition",
            "settleAmount",
            "settleStatus",
            "settledDate",
            "unspent",
            "adminMemo",
        ]
    },
    test: {
        all: [
            "id",
            "siteCategory",
            "testAvailableStartDate",
            "testAvailableEndDate",
            "testNation",
            "testCity",
            "testDate",
            "testStartTime",
            "testEndTime",
            "applicationCategory",
            "year",
            "round",
            "testSubject",
            "testGrade",
            "category1",
            "category2",
            "category3",
            "examName",
            "detailedDescription",
            "departureLanguage",
            "arrivalLanguage",
            "purpose",
            "defaultValue",
            "order",
            "submittingStartDate",
            "submittingEndDate",
            "submittingStatus",
            "questionFile",
            "fileType",
            "translationToolUsed",
            "aiUsed",
            "testOverview",
            "passingScore",
            "fullScore",
            "searchCount",
            "totalNumberOfQuestions",
            "levelHigh",
            "levelMedium",
            "levelLow",
            "questionSetter",
            "questionSetterContact",
            "applicationStartDate",
            "applicationEndDate",
            "applicationStatus",
            "testingStatus",

            "gradingStartDate",
            "gradingEndDate",
            "gradingStatus",

            "grader",
            "graderContact",
            "announceDate",
            "announceTime",
            "numberOfApplicants",
            "previousNumberOfApplicants",
            "passers",
            "failers",
            "questionSetterMemo",
            "graderMemo",
            "adminMemo"
        ],
        test: [
            "id",
            "testAvailableStartDate",
            "testAvailableEndDate",
            "testNation",
            "testCity",
            "testDate",
            "testStartTime",
            "testEndTime",
            "applicationCategory",
            "year",
            "round",
            "testSubject",
            "testGrade",
            "category1",
            "category2",
            "category3",
            "examName",
            "detailedDescription",
            "departureLanguage",
            "arrivalLanguage",
            "purpose",
            "submittingStartDate",
            "submittingEndDate",
            "submittingStatus",
            "passingScore",
            "fullScore",
            "searchCount",
            "questionSetter",
            "questionSetterContact",
            "applicationStartDate",
            "applicationEndDate",
            "applicationStatus",
            "testingStatus",

            "gradingStartDate",
            "gradingEndDate",
            "gradingStatus",

            "grader",
            "graderContact",
            "announceDate",
            "announceTime",
            "numberOfApplicants",
            "previousNumberOfApplicants",
            "passers",
            "failers",
            "questionSetterMemo",
            "graderMemo",
            "adminMemo"
        ],
        submit: [
            "id",
            "testAvailableStartDate",
            "testAvailableEndDate",
            "testNation",
            "testCity",
            "testDate",
            "testStartTime",
            "testEndTime",
            "applicationCategory",
            "year",
            "round",
            "testSubject",
            "testGrade",
            "category1",
            "category2",
            "category3",
            "examName",
            "detailedDescription",
            "departureLanguage",
            "arrivalLanguage",
            "purpose",
            "submittingStartDate",
            "submittingEndDate",
            "submittingStatus",
            "questionFile",
            "fileType",
            "translationToolUsed",
            "aiUsed",
            "testOverview",
            "passingScore",
            "fullScore",
            "searchCount",
            "totalNumberOfQuestions",
            "levelHigh",
            "levelMedium",
            "levelLow",
            "questionSetter",
            "questionSetterContact",
            "testingStatus",
            "questionSetterMemo",
            "graderMemo",
            "adminMemo"
        ],
    },
    grading:{
        all:[],
    },
    blog:{
        all:[],
    },
    support:{
        all:[],
    },
    site:{
        all:[],
    },
    category:{
        all:[],
    },
    transaction:{
        all:[],
    },
    admin:{
        all:[],
    },
}